module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./StoreGiftbagView.js"));
	}, "StoreGiftbagView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=StoreGiftbagView!./src/pages/Register/StoreGiftbag/StoreGiftbagView.js
// module id = 853
// module chunks = 431